export default __webpack_public_path__ + "static/media/hero-title-2022-2.936dbcbb.png";